import * as styles from './index.css';

export const DesktopNavbar = () => {
  return <div className={styles.topNavLinks}></div>;
};
